import React from "react";
import Image from "next/image";
import { FeatureCardProps } from "../types";

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <div className="feature-card">
      <div className="flex flex-col items-center justify-start px-[15px] py-[10px] h-full">
        <div className="w-[75px] h-[75px] mb-4 mt-2 flex-shrink-0 transform skew-x-12">
          <Image
            src={icon}
            alt={title}
            width={250}
            height={250}
            quality={80}
            className="w-full h-full object-contain"
          />
        </div>

        <h3 className="text-omto-dark font-montserrat font-bold text-[18px] leading-8 text-center mb-1 flex-shrink-0">
          {title}
        </h3>

        <div className="space-y-1 flex-grow flex flex-col justify-start w-full">
          {description.map((line) => (
            <p
              key={line}
              className="text-omto-dark font-montserrat font-medium text-[14px] leading-6"
            >
              {line}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;
